import { Link } from 'react-router-dom';

const footerLinks = {
  main: [
    { label: '首页', path: '/' },
    { label: '赛事分类', path: '/category/football' },
    { label: '关于我们', path: '/about' },
  ],
  sports: [
    { label: '足球', path: '/category/football' },
    { label: '篮球', path: '/category/basketball' },
    { label: '网球', path: '/category/tennis' },
    { label: '电竞', path: '/category/esports' },
    { label: '乒乓球', path: '/category/table-tennis' },
    { label: '棒球', path: '/category/baseball' },
  ],
  support: [
    { label: '帮助中心', path: '/about' },
    { label: '常见问题', path: '/' },
    { label: '联系我们', path: '/about' },
    { label: '用户协议', path: '/about' },
    { label: '隐私政策', path: '/about' },
  ],
};

export default function Footer() {
  const scrollToFAQ = () => {
    const el = document.getElementById('faq-section');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-background-950 text-background-50 pt-14 pb-8">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-line text-2xl text-accent-500"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50">开云体育</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              开云体育在线是您最值得信赖的体育娱乐平台，提供丰富的体育赛事投注与实时赔率更新服务。
            </p>
            <div className="flex items-center gap-3">
              <a href="https://t.me/kaiyunsport" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-accent-500 transition-colors duration-200" aria-label="Telegram">
                <i className="ri-telegram-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-accent-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-accent-500 transition-colors duration-200" aria-label="邮件">
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.main.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门赛事</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.sports.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">客户服务</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.support.map((link) => (
                <li key={link.label}>
                  {link.path === '/' && link.label === '常见问题' ? (
                    <button onClick={scrollToFAQ} className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                      {link.label}
                    </button>
                  ) : (
                    <Link to={link.path} className="text-sm text-background-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap">
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 开云体育在线 版权所有。保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500">安全认证</span>
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-shield-check-line text-background-500 text-sm"></i>
              </div>
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-lock-line text-background-500 text-sm"></i>
              </div>
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-verified-badge-line text-background-500 text-sm"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}